// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager
} from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBCr-M8udMQExDdrCJTrdpH02iSAHqMkgA",
  authDomain: "analytebudget.firebaseapp.com",
  projectId: "analytebudget",
  storageBucket: "analytebudget.firebasestorage.app",
  messagingSenderId: "798378105649",
  appId: "1:798378105649:web:f3877774e5b423ee282e10",
  measurementId: "G-XXNQSX7NGD"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
});